import { Link } from "react-router-dom";
import logoimg from "../assets/images/logo.png";

function Footer() {
  return (
    <>

    <div className="footer-banner-bottom">

  <h2>Follow Us for latest updates</h2>

  <div className="footer-banner-icons">

    {/* TELEGRAM */}
    <a
      href="https://t.me/swiftintelli_techtraining"
      target="_blank"
      rel="noreferrer"
    >
      <img
        src="https://cdn-icons-png.flaticon.com/512/2111/2111646.png"
        alt="Telegram"
      />
    </a>

    {/* YOUTUBE */}
    <a
      href="https://www.youtube.com/@SWIFTINTELLI"
      target="_blank"
      rel="noreferrer"
    >
      <img
        src="https://cdn-icons-png.flaticon.com/512/1384/1384060.png"
        alt="YouTube"
      />
    </a>

    {/* WHATSAPP */}
    <a
      href="https://whatsapp.com/channel/0029Vb7x7UYGE56i2ifcC50R"
      target="_blank"
      rel="noreferrer"
    >
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
        alt="WhatsApp"
      />
    </a>

  </div>

</div>
      <footer className="si-footer">

        <div className="si-footer-top">

          {/* BRAND */}
          <div className="si-footer-brand">
            <img
              src={logoimg}
              alt="SwiftIntelli Logo"
              className="si-logo"
            />

            <p>
              Empowering the next generation of tech professionals through
              immersive, project-driven learning experiences.
            </p>
          </div>

          {/* NAVIGATE */}
          <div className="si-footer-col">
            <h4>NAVIGATE</h4>

            {[
  ["/about", "About"],
  ["/why-swiftintelli", "Why SwiftIntelli"],
  ["/our-courses", "Courses"],
  ["/contact", "Contact"],
].map(([h, l]) => (
              <Link key={l} to={h}>
                {l}
              </Link>
            ))}
          </div>

          {/* COURSES */}
          <div className="si-footer-col">
            <h4>COURSES</h4>

            {[
              "AI / Machine Learning",
              "IoT Systems",
              "Robotics",
              "Prompt Engineering",
            ].map((c) => (
              <Link key={c} to="/our-courses">
                {c}
              </Link>
            ))}
          </div>

          {/* CONNECT */}
          <div className="si-footer-col">
            <h4>CONNECT</h4>

            <Link to="https://linkedin.com/" target="_blank" rel="noreferrer">
              LinkedIn
            </Link>

            <Link to="https://instagram.com/" target="_blank" rel="noreferrer">
              Instagram
            </Link>

            <Link
              to="https://t.me/swiftintelli_techtraining"
              target="_blank"
              rel="noreferrer"
            >
              Telegram
            </Link>

            <Link
              to="https://www.youtube.com/@SWIFTINTELLI"
              target="_blank"
              rel="noreferrer"
            >
              YouTube
            </Link>
          </div>

        </div>

        {/* BOTTOM */}
        <div className="si-footer-bottom">

          <span>© 2026 SwiftIntelli. All rights reserved.</span>

          
          {/* <span>Privacy Policy · Terms of Service</span> */}

        </div>

        {/* WHATSAPP FLOAT */}
        {/* WHATSAPP FLOAT */}
<Link
  to="https://wa.me/919391966251"
  className="whatsapp-float"
  target="_blank"
  rel="noreferrer"
>
  <img
    src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
    alt="WhatsApp"
  />
</Link>

      </footer>
    </>
  );
}

export default Footer;